import { LandingLayoutWithoutSidebar } from "PFApp/components/landing_layout";
import { useOnboarding } from "PFApp/onboarding/use_onboarding";
import { DefaultTermsOfService } from "PFApp/terms_of_service/default_terms_of_service";
import { Button } from "PFComponents/button";
import { Markdown } from "PFComponents/markdown";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import OnboardingBox from "../parts/onboarding_box";
import css from "./common.less";

const CREDENTIALS_STATUSES = ["credentials", "new", ""];

const TermsAndConditionsStep = () => {
  const { currentAccount, currentProfile, saveProfile, navigateNext } = useOnboarding("tos");
  const { t } = useTranslation("onboarding");

  const customization = currentAccount.customization || {};

  useEffect(() => {
    const noTos = customization.show_terms_and_conditions === false;
    const atCredentials = CREDENTIALS_STATUSES.includes(currentProfile.registration_status);

    if (noTos || !atCredentials) {
      navigateNext();
    }
  }, []);

  const clickAgree = () => {
    const data = { agree_to_terms_and_conditions: true, registration_status: "terms_of_service" };
    saveProfile(data).then(navigateNext);
  };

  const rawCopy = customization?.terms_and_conditions?.trim();

  return (
    <LandingLayoutWithoutSidebar>
      <OnboardingBox big qaId="Onboarding.TermsAndConditionsStep">
        {rawCopy ? <Markdown raw={rawCopy} crop={1e10} emojify={false} /> : <DefaultTermsOfService />}
        <div className={css.center} style={{ marginTop: 50 }}>
          <Button onClick={clickAgree}>{t("iAgree")}</Button>
        </div>
      </OnboardingBox>
    </LandingLayoutWithoutSidebar>
  );
};

export default TermsAndConditionsStep;
